import {
    UpdateIcon,
} from '@radix-ui/react-icons';
import { useCallback, useState } from 'react';
import api from '../../lib/api';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { Input } from '../ui/input';
import { toast } from '../ui/use-toast';

function LendBunnyDialog({ bunny, fetchDrivers, className }) {

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [email, setEmail] = useState('');
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const handleChange = async (e) => {
        e.preventDefault();
        if (isLoading) return;

        setIsLoading(true);
        setError(null);

        try {
            const response = await api.post(`https://skhrf-api.cmdigital.se/v1/bunnies/lend`, {
                lendToEmail: email,
                bunnyId: bunny.id,
            });
            fetchDrivers();
            toast({
                title: 'Kanin utlånad',
                description: `${bunny.name} blev utlånad till användare med e-post ${email}`,
            });
            setIsDialogOpen(false);
        } catch (error) {
            setError(error?.response?.data?.error);
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error?.response?.data?.error,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleEmailChange = useCallback((e) => {
        setEmail(e.target.value);
    }, []);

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DialogTrigger className={`flex items-center w-full ${className}`} asChild>
                <Button>
                    Låna ut
                </Button>
            </DialogTrigger>
            <DialogContent className="flex flex-col gap-6">
                <DialogHeader className='text-left'>
                    <DialogTitle>Låna ut kanin</DialogTitle>
                    <DialogDescription>Ange en användares e-postadress för att låna ut {bunny.name}</DialogDescription>
                </DialogHeader>
                <Input
                    id='email'
                    type='email'
                    placeholder='hej@cmdigital.se'
                    value={email}
                    onChange={handleEmailChange}
                    autoComplete='off'
                />
                <div className='grid grid-cols-2 gap-3'>
                    <DialogClose asChild>
                        <Button className='h-full' type='button' variant='secondary'>Avbryt</Button>
                    </DialogClose>
                    <Button className='whitespace-normal h-fit' type="submit" onClick={handleChange} disabled={isLoading}>
                        {isLoading ? <UpdateIcon className='loader-spinner' /> : <>Låna ut</>}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default LendBunnyDialog;
